import { Box, Typography, Tooltip } from '@mui/material';
import { PNG } from 'components/Asset/PNG';
import useAppTheme from 'hooks/useAppTheme';
import { CLIENT_THEME, clientThemePalette } from 'utils/clientTheme';

export const HighestCostingCard = ({
  icon,
  title,
  name,
  subName,
  value,
  usePngComponent,
  otherIds,
}: {
  icon: string | null;
  title: string | null;
  name: string | null;
  subName: string | null;
  value: string | null;
  usePngComponent: boolean;
  otherIds?: string[] | null;
}) => {
  const { enableDarkTheme } = useAppTheme();
  const palette = enableDarkTheme
    ? clientThemePalette[CLIENT_THEME].dark
    : clientThemePalette[CLIENT_THEME].light;
  const thumbnailBackground =
    CLIENT_THEME === 'yokohama'
      ? 'transparent'
      : enableDarkTheme
      ? '#1C3459'
      : '#EEEEEE';

  return (
    <Box display="flex" flexDirection="column" gap={1} width={'100%'}>
      <Box>
        <Typography
          sx={{
            color: palette.grey,
          }}
          fontSize={'12px'}
        >
          {title}
        </Typography>
      </Box>
      <Box
        display={'flex'}
        flexDirection={'row'}
        alignItems={'center'}
        gap={1}
        justifyContent={'space-between'}
      >
        <Box
          display={'flex'}
          flexDirection={'row'}
          gap={1}
          alignItems={'center'}
        >
          {icon &&
            (usePngComponent ? (
              <Box>
                <Box
                  width={'60px'}
                  display={'flex'}
                  alignItems={'center'}
                  justifyContent={'center'}
                >
                  <Box
                    height={'35px'}
                    width={'35px'}
                    display="flex"
                    alignItems="center"
                    justifyContent="center"
                    sx={{
                      position: 'relative',
                      borderRadius: '50%',
                      background: thumbnailBackground,

                      zIndex: 1,
                    }}
                  >
                    <Box
                      component={PNG}
                      name={icon}
                      alt={'alt'}
                      sx={{
                        position: 'absolute',
                        width: '70px',
                        height: '70px',
                        objectFit: 'contain',
                        zIndex: 2,
                        left: '50%',
                        top: '50%',
                        transform: 'translate(-50%, -50%)',
                      }}
                    />
                  </Box>
                </Box>
              </Box>
            ) : (
              <Box>
                <Box
                  width={'60px'}
                  display={'flex'}
                  alignItems={'center'}
                  justifyContent={'center'}
                >
                  <Box
                    height={'35px'}
                    width={'35px'}
                    display="flex"
                    alignItems="center"
                    justifyContent="center"
                    sx={{
                      position: 'relative',
                      borderRadius: '50%',
                      background: thumbnailBackground,

                      zIndex: 1,
                    }}
                  >
                    <img
                      src={icon}
                      alt={'alt'}
                      style={{
                        position: 'absolute',
                        objectFit: 'contain',
                        zIndex: 2,
                        left: '50%',
                        top: '50%',
                        transform: 'translate(-50%, -50%)',
                        height: '40px',
                        width: '40px',
                      }}
                    />
                  </Box>
                </Box>
              </Box>
            ))}

          <Box>
            <Typography
              style={{
                color: palette.textPrimary,
                fontWeight: 600,
              }}
              variant="body2"
            >
              {name}
              {otherIds && otherIds.length > 0 && (
                <Tooltip
                  title={
                    <Box>
                      {otherIds.slice(1).map((msg, index) => (
                        <div key={index}>{msg}</div>
                      ))}
                    </Box>
                  }
                  placement="top"
                  arrow
                >
                  <sup
                    style={{
                      cursor: 'pointer',
                      marginLeft: 2,
                      fontSize: '0.7em',
                      verticalAlign: 'super',
                      color: palette.grey,
                    }}
                  >
                    +{otherIds.length - 1}
                  </sup>
                </Tooltip>
              )}
            </Typography>
            {subName && (
              <Typography
                style={{
                  color: palette.textPrimary,
                  fontSize: '12px',
                }}
                variant="body2"
              >
                {subName}
              </Typography>
            )}
          </Box>
        </Box>
        <Box>
          <Typography
            style={{
              color: palette.textPrimary,
              fontSize: '16px',
              fontWeight: 600,
            }}
            variant="body2"
          >
            {value}
          </Typography>
        </Box>
      </Box>
    </Box>
  );
};
